import React from 'react'

const GlobalFilterKarty = ({filter, setFilter}) => {
  return (
    <span>
        <input className='inputHledejKarty' placeholder='Hledaný výraz' value={filter || ''} onChange={(e) => setFilter(e.target.value)} />
    </span>
  )
}

export default GlobalFilterKarty